import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Swipeable } from 'react-swipeable';
import s from './Duperswiper.scss';
var Duperswiper = function (_a) {
    var children = _a.children, deviation = _a.deviation, width = _a.width, height = _a.height, _b = _a.navigation, nextItem = _b.nextItem, prevItem = _b.prevItem, isEnabled = _a.isEnabled, moveNext = _a.moveNext, movePrev = _a.movePrev;
    var _c = useState(0), xOffset = _c[0], setOffset = _c[1];
    var onSwipingLeft = useCallback(function (absX) {
        if (!nextItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(-absX);
    }, [nextItem, xOffset]);
    var onSwipingRight = useCallback(function (absX) {
        // do nothing if there's nothing in the current direction
        if (!prevItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(absX);
    }, [prevItem, xOffset]);
    var onSwiping = useCallback(function (_a) {
        var dir = _a.dir, absX = _a.absX;
        switch (dir) {
            case 'Left':
                onSwipingLeft(absX);
                return;
            case 'Right':
                onSwipingRight(absX);
                return;
            default:
        }
    }, [onSwipingLeft, onSwipingRight]);
    var onSwipedLeft = useCallback(function () {
        if (!nextItem) {
            setOffset(0);
            return;
        }
        setOffset(width ? -width : '-100%');
        moveNext();
    }, [moveNext, nextItem, width]);
    var onSwipedRight = useCallback(function () {
        if (!prevItem) {
            setOffset(0);
            return;
        }
        setOffset(width || '100%');
        movePrev();
    }, [movePrev, prevItem, width]);
    if (!isEnabled) {
        return React.createElement(React.Fragment, null, children(deviation));
    }
    var transformStyle = { transform: "translateX(" + xOffset + "px)" };
    return (React.createElement(Swipeable, { trackMouse: true, onSwiping: onSwiping, onSwipedLeft: onSwipedLeft, onSwipedRight: onSwipedRight, className: s['swipeable'] },
        React.createElement("div", { className: s['root'], style: { width: width, height: height } },
            React.createElement("div", { style: transformStyle, className: s['transform'] }, children(deviation)),
            prevItem && xOffset > 0 && (React.createElement("div", { style: transformStyle, className: classnames(s['preview'], s['prev']) }, children(prevItem))),
            nextItem && xOffset < 0 && (React.createElement("div", { style: transformStyle, className: classnames(s['preview'], s['next']) }, children(nextItem))))));
};
Duperswiper.displayName = 'Duperswiper';
export default Duperswiper;
//# sourceMappingURL=Duperswiper.js.map